module.exports = __webpack_public_path__ + "static/media/11-2.c41eb384.mp3";